// src/lib/authApi.js
// Helperlaag voor calls naar de Bond HTTP API

function resolveApiBase() {
  if (typeof window !== "undefined") {
    const host = window.location.hostname;

    // 1. Dev: als we op localhost draaien → altijd de lokale backend gebruiken
    if (host === "localhost") {
      return "http://localhost:5000";
    }

    // 2. Productie: bondapp.tv → productie backend
    if (host === "bondapp.tv") {
      return "https://signal.bondapp.tv"; // productie backend
    }

    // 3. Optioneel: als er een env is gezet (bijv. staging / andere omgevingen)
    if (process.env.REACT_APP_API_BASE) {
      return process.env.REACT_APP_API_BASE;
    }

    // 4. Andere hosts (bijv. 192.168.x.x) → zelfde host, poort 5000
    return `http://${host}:5000`;
  }

  // Fallback (geen window, bijv. tijdens build)
  if (process.env.REACT_APP_API_BASE) {
    return process.env.REACT_APP_API_BASE;
  }

  return "http://localhost:5000";
}

const API_BASE = resolveApiBase();

console.log("BOND API_BASE =", API_BASE);

async function request(path, { method = "GET", body, token } = {}) {
  const headers = {
    "Content-Type": "application/json",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok || data.ok === false) {
    const errorCode =
      data?.error ||
      (res.status === 401 ? "UNAUTHENTICATED" : "REQUEST_FAILED");
    const err = new Error(errorCode);
    err.code = errorCode;
    err.status = res.status;
    throw err;
  }

  return data;
}

/** ---------- Auth (legacy password-based) ---------- **/

export async function apiSignup({ email, password, name }) {
  const data = await request("/api/signup", {
    method: "POST",
    body: { email, password, name },
  });
  return data; // { ok, token, user }
}

export async function apiLogin({ email, password }) {
  const data = await request("/api/login", {
    method: "POST",
    body: { email, password },
  });
  return data; // { ok, token, user }
}

export async function apiGetMe(token) {
  const data = await request("/api/me", { method: "GET", token });
  return data; // { ok, user }
}

/** ---------- Auth (V2: magic link + DB) ---------- **/

// Magic link aanvragen
export async function apiRequestMagicLink({ email, displayName }) {
  const data = await request("/api/auth/magic/request", {
    method: "POST",
    body: { email, displayName },
  });
  return data; // { ok: true }
}

// Magic link consumeren → { ok, token, user }
export async function apiConsumeMagicLink(token) {
  const data = await request("/api/auth/magic/consume", {
    method: "POST",
    body: { token },
  });
  return data; // { ok, token, user }
}

// Huidige user via nieuwe DB-auth (/api/me-v2)
export async function apiGetMeV2(token) {
  const data = await request("/api/me-v2", {
    method: "GET",
    token,
  });
  return data; // { ok, user }
}

/** ---------- Friends + users ---------- **/

export async function apiSearchUsers(query, token) {
  const q = encodeURIComponent(query);
  const data = await request(`/api/users/search?query=${q}`, {
    method: "GET",
    token,
  });
  return data; // { ok, users: [...] }
}

export async function apiGetFriends(token) {
  const data = await request("/api/friends", {
    method: "GET",
    token,
  });
  return data; // { ok, friends: [...] }
}

export async function apiGetFriendRequests(token) {
  const data = await request("/api/friend-requests", {
    method: "GET",
    token,
  });
  return data; // { ok, requests: [...] }
}

export async function apiSendFriendRequest(toUserId, token) {
  const data = await request("/api/friend-requests", {
    method: "POST",
    token,
    body: { toUserId },
  });
  return data;
}

export async function apiRespondFriendRequest(requestId, action, token) {
  const data = await request(`/api/friend-requests/${requestId}/respond`, {
    method: "POST",
    token,
    body: { action },
  });
  return data;
}

/** ---------- Session-invites ---------- **/

export async function apiCreateSessionInvites(sessionCode, toUserIds, token) {
  const data = await request("/api/session-invites", {
    method: "POST",
    token,
    body: { sessionCode, toUserIds },
  });
  return data;
}

// Sessie aanmaken vanaf de FriendsPage (host = ingelogde DB-user)
export async function apiCreateSessionFromFriends(token) {
  const data = await request("/api/sessions/from-friends", {
    method: "POST",
    token,
    body: {}, // nu nog geen extra payload
  });
  return data; // { ok: true, sessionCode }
}

export async function apiGetSessionInvites(token) {
  const data = await request("/api/session-invites", {
    method: "GET",
    token,
  });
  return data;
}



export async function apiRespondSessionInvite(inviteId, action, token) {
  const data = await request(`/api/session-invites/${inviteId}/respond`, {
    method: "POST",
    token,
    body: { action },
  });
  return data;
}

/** ---------- Providers (mijn gekoppelde pakketten) ---------- **/
// Welke providers / pakketten heeft deze user gekoppeld?
export async function apiGetMyProviders(token) {
  const data = await request("/api/me/providers", {
    method: "GET",
    token,
  });
  console.log("[Bond] /api/me/providers →", data);
  return data; // { ok, providers: [...] }
}

